const withdrawalRequests = (state, action) => {
    if (state === undefined) {
        return {
            withdrawalRequestsList: undefined
        }
    }
    switch (action.type) {
        case 'SET_WITHDRAWAL_REQUESTS':
            return {
                withdrawalRequestsList: action.payload,
            };
        default:
            return state.withdrawalRequests;
    }
};

export {withdrawalRequests}
